import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Input,
  SimpleChanges,
} from "@angular/core";
import { ImageManagerService } from "src/app/services/image-manager.service";

@Component({
  selector: "app-blob-image",
  templateUrl: "./blob-image.component.html",
  styleUrls: ["./blob-image.component.css"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlobImageComponent implements OnInit, OnDestroy {
  /**
   * Data of image
   *
   * @type {Blob | { file: ArrayBuffer, type: string}}
   * @memberof BlobImageComponent
   */
  @Input()
  photoFile: any;

  @Input()
  arrayBufferFormat: boolean;

  urlSanitized: any;
  private currentBlobUrl: string | null = null;

  constructor(private imageService: ImageManagerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["photoFile"] &&
      changes["photoFile"].currentValue &&
      changes["photoFile"].currentValue.changed
    ) {
      try {
        URL.revokeObjectURL(this.photoFile.previewUrl);
      } catch (e) {
        console.log("error", e);
      }
      const blob = this.arrayBufferFormat
        ? this.imageService.arrayBufferToBlob(
            this.photoFile.file,
            this.photoFile.type
          )
        : this.photoFile;
      // Genera nuovo URL e aggiornalo nel photoFile per uso futuro
      const newBlobUrl = URL.createObjectURL(blob);
      this.currentBlobUrl = newBlobUrl;
      if (this.photoFile && typeof this.photoFile === "object") {
        this.photoFile.previewUrl = newBlobUrl;
      }
      this.urlSanitized = this.imageService.generateSafeUrlFromBlob(blob);
    }
  }

  ngOnInit() {
    try {
      URL.revokeObjectURL(this.photoFile.previewUrl);
    } catch (e) {
      // URL già invalido, ignora errore
    }
    const blob = this.arrayBufferFormat
      ? this.imageService.arrayBufferToBlob(
          this.photoFile.file,
          this.photoFile.type
        )
      : this.photoFile;
    const newBlobUrl = URL.createObjectURL(blob);
    this.currentBlobUrl = newBlobUrl;
    if (this.photoFile && typeof this.photoFile === "object") {
      this.photoFile.previewUrl = newBlobUrl;
    }
    this.urlSanitized = this.imageService.generateSafeUrlFromBlob(blob);
  }

  /**
   * Verifica se un blob URL è ancora valido
   * Dopo un refresh del browser, i blob URL diventano invalidi
   */
  private isValidBlobUrl(url: string): boolean {
    if (!url || !url.startsWith("blob:")) {
      return false;
    }

    try {
      // Verifica se l'URL è ancora accessibile
      // I blob URL invalidi causano errori di sicurezza
      return document.location.origin === new URL(url).origin;
    } catch (error) {
      return false;
    }
  }

  ngOnDestroy(): void {
    if (this.currentBlobUrl) {
      URL.revokeObjectURL(this.currentBlobUrl);
      this.currentBlobUrl = null;
    }
  }
}
